module.exports = __webpack_public_path__ + "static/media/play.c20eeab7.png";